import React, {
    ReactElement, useState,
} from "react";
import { Dropdown } from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import { BiCheckSquare, BiSquareRounded } from "react-icons/bi";
import { GrFormFilter } from "react-icons/gr";
import {
    useGetTemplatesQuery,
} from "../../../../__generated__/api";
import { Loading } from "../../../../components";
import useRouting, { Link } from "../../../../contexts/Routing";
import { ErrorRemote } from "../../../error/Error";
import Avatar from "../../../../components/avatar/Avatar";
import { JOB_FUNCTION_NAME } from "../../../administrator/sections/request-form/RequestForm";
import { Filters } from "../../../../components/filters/Filters";

export default function FormTemplates(): ReactElement {
    const { data, error, loading: isLoading } = useGetTemplatesQuery({
        fetchPolicy: "no-cache",
    });
    const { Paths } = useRouting();

    const [jobFilters, setJobFilters] = useState<Set<string>>(() => new Set());
    const [formSearch, setFormSearch] = useState<string>("");

    if (isLoading) {
        return <Loading />;
    }
    if (error || !data) {
        return <ErrorRemote error={error} />;
    }

    let { forms } = data;

    if (jobFilters.size > 0) {
        forms = forms?.filter(row => row.jobFunctions?.isEmpty || row.jobFunctions?.some(id => jobFilters.has(id)));
    }
    if (formSearch) {
        const search = formSearch.toLocaleLowerCase();
        forms = forms?.filter(row => row.name.toLocaleLowerCase().includes(search)
            || row.description?.toLocaleLowerCase().includes(search));
    }

    return (
        <div className="d-flex align-items-stretch">

            <div className="border p-3 rounded  bg-white col ms-2">
                {forms?.isNotEmpty ? (
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="text-light mb-0">
                                Templates
                            </h5>
                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "template",
                                    setting: "request-forms",
                                }}
                                className="btn btn-none btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Template
                            </Link>
                        </div>
                        <Filters
                            categories={data.forms
                                .flatMap(row => row.jobFunctions ?? [])
                                .dedupe()
                                .map(job => ({
                                    value: job,
                                    label: JOB_FUNCTION_NAME[job],
                                }))}
                            selectedCategories={jobFilters}
                            onSelected={setJobFilters}
                            search={formSearch}
                            onSetSearch={setFormSearch}
                        />
                        {forms.isNotEmpty ? (

                            <div className="list-group">
                                {forms?.map(template => (
                                    <Link
                                        to={Paths.ADMINISTRATOR_SETTING_ID}
                                        key={template.id}
                                        params={{
                                            id: template.id,
                                            setting: "request-forms",
                                        }}
                                        className="list-group-item list-group-item-action
                                            d-flex align-items- justify-content-between"
                                    >
                                        <div className="col-1">
                                            <Avatar src={template.iconUrl as string} />
                                        </div>
                                        <div className="d-flex flex-column flex-grow-1">
                                            <div className="d-flex w-100 align-items-end mb-2">
                                                <h5 className="mb-0">
                                                    {template.name}
                                                    {" "}
                                                </h5>

                                                <small className="ms-3 text-light " />
                                            </div>
                                            <small>{template.description}</small>
                                        </div>
                                        <div>
                                            {template.jobFunctions?.map(job => (
                                                <span key={job} className="badge bg-primary me-1">
                                                    {JOB_FUNCTION_NAME[job]}
                                                </span>
                                            ))}
                                        </div>

                                    </Link>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center text-light">No request types found matching your filters.</div>
                        )}
                        <div className="d-flex justify-content-end align-items-center mt-3">

                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "template",
                                    setting: "request-forms",
                                }}
                                className="btn btn-secondary btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Template Type
                            </Link>
                        </div>

                    </>
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-light my-4">
                        <h5 className="text-light">
                            Template
                        </h5>
                        <Link
                            to={Paths.ADMINISTRATOR_SETTING_ID}
                            params={{
                                id: "template",
                                setting: "request-forms",
                            }}
                            className="btn btn-secondary btn-sm my-3"
                        >
                            <AiOutlinePlus />
                            {" "}
                            Add Template
                        </Link>
                        <small>
                            Request types allow you to automate your workflow. Imagine your customers are always
                            asking for access to a certain product or feature. Create a request type which automatically
                            asks users which product or feature they would like access to, triggers an approval workflow
                            from their manager, and once approved automatically initiates a workflow through an integration.
                            Add a request type to see how.
                        </small>
                    </div>

                )}

            </div>

        </div>
    );
}
